.dj{background:var(--palette-white);}